
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.834 6.364l-5.42-.79L10.99.66c-.435-.876-1.693-.887-2.13 0L6.438 5.574l-5.421.79C.045 6.504-.345 7.704.36 8.39l3.922 3.822-.928 5.398c-.167.976.861 1.707 1.722 1.25l4.85-2.548 4.85 2.549c.86.453 1.888-.275 1.72-1.25l-.927-5.4 3.922-3.821c.705-.687.316-1.885-.657-2.026zm-5.176 5.224l.88 5.136L9.926 14.3l-4.613 2.423.88-5.136L2.46 7.952l5.158-.75 2.308-4.675 2.307 4.676 5.158.749-3.733 3.636z","fill":"currentColor"}})])
          )
        }
      }
    